import { CONTAINER_MAX } from '@/constants/breakpoints';
import { ContainerBreakpointsType } from '@/constants/common';

import { useBreakpointQuery } from './useBreakpointQuery';

export const useBelow = (bp: ContainerBreakpointsType, ssrDefault = false) =>
  useBreakpointQuery(`(max-width: ${CONTAINER_MAX[bp]})`, ssrDefault);
